import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  LoanConflictResolutionRequest,
  LoanConflictResolutionService,
} from 'src/app/services/loan-conflict-resolution.service';

@Component({
  selector: 'loan-update-conflict-notification',
  templateUrl: './loan-update-conflict-notification.component.html',
  styleUrls: ['./loan-update-conflict-notification.component.scss'],
  standalone: false
})
export class LoanUpdateConflictNotificationComponent implements OnInit, OnDestroy {
  pendingRequest: LoanConflictResolutionRequest | null = null;
  expanded = true;

  private _subscription: Subscription | null = null;

  constructor(private readonly _resolutionService: LoanConflictResolutionService) {}

  ngOnInit(): void {
    this._subscription = this._resolutionService.pendingConflicts$.subscribe(request => {
      this.pendingRequest = request;
      if (request) {
        this.expanded = true;
      }
    });
  }

  openResolution(): void {
    void this._resolutionService.openPendingConflicts();
  }

  collapse(): void {
    this.expanded = false;
  }

  expand(): void {
    this.expanded = true;
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
